import React, { useEffect, useState } from "react";

import {
  Row,
  Col,
  Form,
  Button,
  ButtonGroup,
  Card,
  Nav,
} from "react-bootstrap";

import PageTitle from "../components/common/PageTitle";
import { useTranslation } from "react-i18next";
import api from "../api/api";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import "./AdminManagement.css";

const UsersList = () => {
  const { t } = useTranslation();

  const [msgServer, setMsg] = useState("");

  const [classMsg, setCmsg] = useState("");
  const [displayMsg, setDispMsg] = useState("hide");
  const [iconMsg, setIconMsg] = useState("info");

  const location = useLocation();

  const [SearchEmail, setSearchEmail] = useState("");
  const [SearchName, setSearchName] = useState("");
  const [SearchRole, setSearchRole] = useState("");

  const [existSuppliers, setExistSuppliers] = useState([]);

  // Get USERS LIST

  const [users, setUsers] = useState([]);

  useEffect(() => {
    const getExistSuppliers = async () => {
      await api
        .get("/admin/exist-suppliers")
        .then((response) => {
          var Data = response.data.suppliers;
          setExistSuppliers(Data);
        })
        .catch((err) => {
          console.error(err);
        });
    };
    getExistSuppliers();
    getUsersList();
  }, []);

  const getUsersList = async () => {
    let data = await api.get("/admin/users").then((response) => {
      let usersData = response.data.users;
      setUsers(usersData);
    });
  };

  // Delete Users Handle

  const handleDelete = async (userUid) => {
    let data = {
      user_uid: userUid,
    };
    return await api
      .delete("/admin/delete-user", { data: data })
      .then((response) => {
        if (response.data.type && response.data.type == "danger") {
          swal({
            title: `${t("cannot_delete")}`,
            icon: "warning",
          });
          return false;
        }
        if (response.data.type == "success") {
          getUsersList();
          setMsg(`${t("delete_success_user")}`);
          setCmsg("success");
          setDispMsg("show");
          setIconMsg("check");
          hideMsg();
          return true;
        }
        return false;
      })
      .catch((error) => {
        swal({
          title: `${t("cannot_delete")}`,
          icon: "error",
          text: t("error"),
        });
        return false;
      });
  };
  const hideMsg = () => {
    setTimeout(() => {
      setDispMsg("hide");
    }, 3000);
  };

  const confirmDelete = (userUid) => {
    swal({
      title: `${t("are_you_sure")}`,
      text: `${t("confirm_delete")}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then(async (Delete) => {
        if (Delete) {
          const deleted = await handleDelete(userUid);
          if (deleted) {
            swal(`${t("delete_success_user")}`, {
              icon: "success",
            });
          }
        }
      })
      .catch((error) => {
        swal({
          title: `${t("cannot_delete")}`,
          icon: "error",
          text: t("error"),
        });
      });
  };

  // Active/Desactive Users Accounts

  const desactivateUser = (userUid) => {
    let data = {
      user_uid: userUid,
    };
    api
      .post("/admin/desactivate-user", data)
      .then((response) => {
        if (response.data.type == "success") {
          swal(t("user_desactivated_success"), {
            icon: "success",
          });
          getUsersList();
          // setActive(false)
        }
        if (response.data.type && response.data.type == "danger") {
          swal({
            icon: "error",
            title: t("oops"),
            text: t("error_desactivate_user"),
          });
          return false;
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: t("oops"),
          text: t("error_desactivate_user"),
        });
      });
  };

  const activateUser = (userUid) => {
    let data = {
      user_uid: userUid,
    };
    api
      .post("/admin/activate-user", data)
      .then((response) => {
        if (response.data.type == "success") {
          swal(t("user_activated_success"), {
            icon: "success",
          });
          getUsersList();
          // setActive(false)
        }
        if (response.data.type && response.data.type == "danger") {
          swal({
            icon: "error",
            title: t("oops"),
            text: t("error_activate_user"),
          });
          return false;
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: t("oops"),
          text: t("error_activate_user"),
        });
      });
  };

  const confirmUser = (userUid) => {
    let data = {
      user_uid: userUid,
    };
    api
      .post("/admin/confirm-user", data)
      .then((response) => {
        if (response.data.type == "success") {
          swal(t("user_confirmed_success"), {
            icon: "success",
          });
          getUsersList();
          // setActive(false)
        }
        if (response.data.type && response.data.type == "danger") {
          swal({
            icon: "error",
            title: t("oops"),
            text: t("error_confirm_user"),
          });
          return false;
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: t("oops"),
          text: t("error_confirm_user"),
        });
      });
  };

  // MODIFIED: Filtering logic for DataGrid
  const filteredUsers = users.filter((user) => {
    if (SearchName !== "") {
      return user.name.toLowerCase().includes(SearchName.toLowerCase());
    }
    if (SearchEmail !== "") {
      return user.email.toLowerCase().includes(SearchEmail.toLowerCase());
    }
    if (SearchRole !== "") {
      return user.role.toLowerCase().includes(SearchRole.toLowerCase());
    }
    return user;
  });

  const navigate = useNavigate();
  const selectUser = (userUid) => {
    navigate(`/admin/user/${userUid}`);
  };

  const displayBasedOnRole = (role) => {
    switch (role) {
      case "ROLE_USER":
        return t("user");
        break;
      case "ROLE_ADMIN":
        return t("admin");
        break;
      case "ROLE_SUPPLIER":
        return t("supplier");
        break;
      default:
        return t("user");
    }
  };

  // ADDED: Helper function to get supplier name
  const getSupplierName = (supplierId) => {
    const supplier = existSuppliers.find((data) => data.id === supplierId);
    return supplier ? supplier.name : "-";
  };

  // ADDED: DataGrid columns configuration
  const columns = [
    {
      field: "name",
      headerName: t("name"),
      flex: 1,
      minWidth: 150,
    },
    {
      field: "email",
      headerName: t("email"),
      flex: 1,
      minWidth: 200,
    },
    {
      field: "phone_number",
      headerName: t("phone_number"),
      flex: 1,
      minWidth: 130,
    },
    {
      field: "role",
      headerName: t("role"),
      flex: 1,
      minWidth: 120,
      valueGetter: (value, row) => displayBasedOnRole(row.role),
    },
    {
      field: "pack",
      headerName: "Pack",
      flex: 1,
      minWidth: 110,
      valueGetter: (value, row) => row.pack || "-",
    },
    {
      field: "supplier",
      headerName: t("supplier"),
      flex: 1,
      minWidth: 150,
      valueGetter: (value, row) => getSupplierName(row.supplier_id),
    },
    {
      field: "created_at",
      headerName: t("created_at"),
      flex: 1,
      minWidth: 130,
      valueGetter: (value) => new Date(value).toLocaleString().slice(0, 10),
    },
    {
      field: "actions",
      headerName: t("actions"),
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        const user = params.row;
        if (user.deleted_at == null) {
          return (
            <ButtonGroup size="sm" className="mr-2">
              <Button
                title={t("edit")}
                onClick={() => selectUser(user.uid)}
              >
                <i className="material-icons">&#xe3c9;</i>
              </Button>
              {user.is_active == 1 ? (
                <Button
                  title={t("deactivate")}
                  onClick={() => desactivateUser(user.uid)}
                  variant="secondary"
                >
                  <i className="material-icons">&#xe510;</i>
                </Button>
              ) : (
                <Button
                  title={t("activate")}
                  onClick={() => activateUser(user.uid)}
                  variant="success"
                >
                  <i className="material-icons">&#xe7fd;</i>
                </Button>
              )}
              {user.is_valid != 1 && (
                <Button
                  title={t("confirm")}
                  onClick={() => confirmUser(user.uid)}
                  variant="success"
                >
                  <i className="material-icons">&#xe5ca;</i>
                </Button>
              )}
              <Button
                title={t("delete")}
                onClick={() => confirmDelete(user.uid)}
                variant="danger"
              >
                <i className="material-icons">&#xe872;</i>
              </Button>
            </ButtonGroup>
          );
        }
        return null;
      },
    },
  ];

  // ADDED: Prepare rows for DataGrid with unique id
  const rows = filteredUsers.map((user) => ({
    ...user,
    id: user.id || user.uid, // DataGrid requires an 'id' field
  }));

  return (
    <>
      <div className="admin-management-page container">
        <Row noGutters className="page-header admin-management-heading">
          <PageTitle
            sm="4"
            title={t("list_users")}
            subtitle={t("list_users")}
            className="text-sm-left"
          />
        </Row>
        <Nav
          variant="pills"
          justified
          activeKey={location.pathname}
          className="admin-management-tabs"
        >
          <Nav.Item>
            <Nav.Link as={Link} to="/admin/users" eventKey="/admin/users">
              {t("list_users")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              as={Link}
              to="/admin/all-suppliers"
              eventKey="/admin/all-suppliers"
            >
              {t("all_suppliers")}
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <section className="admin-management-toolbar">
          <div className="admin-management-toolbar-title">
            <i className="fas fa-filter" aria-hidden="true" />
            {t("search_users")}
          </div>
        <Row form className="admin-management-filters">
          <Col className="form-group">
            <Form.Group>
              <div className="d-flex">
                <Form.Control
                  value={SearchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  id="search-name"
                  placeholder={t("search_by_name")}
                />
              </div>
            </Form.Group>
          </Col>
          <Col className="form-group">
            <Form.Group>
              <div className="d-flex">
                <Form.Control
                  value={SearchRole}
                  onChange={(e) => setSearchRole(e.target.value)}
                  id="search-role"
                  placeholder={t("search_by_role")}
                />
              </div>
            </Form.Group>
          </Col>
          <Col className="form-group">
            <Form.Group>
              <div className="d-flex">
                <Form.Control
                  value={SearchEmail}
                  onChange={(e) => setSearchEmail(e.target.value)}
                  id="search-email"
                  placeholder={t("search_by_email")}
                />
              </div>
            </Form.Group>
          </Col>
        </Row>
        </section>
        <section className="admin-management-toolbar">
          <div className="admin-management-toolbar-title">
            <i className="fas fa-bolt" aria-hidden="true" />
            {t("my_actions")}
          </div>
        <Row form>
          <div className="admin-management-actions">
            <Button onClick={() => navigate("/admin/deleted-users")}>
              {t("deleted_users")}
            </Button>
            <Button onClick={() => navigate("/admin/add-user")}>
              {t("add_user")}
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => navigate("/Supplier")}
            >
              {t("add_company")}
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => navigate("/admin/sensors")}
            >
              {t("assign_sensor")}
            </Button>
          </div>
        </Row>
        </section>

        {displayMsg === "show" && (
          <div className={`mb-3 alert alert-${classMsg} fade show`}>
            <i className={`fa fa-${iconMsg} mx-2`}></i> {t(msgServer)}
          </div>
        )}

        {/* REPLACED: Traditional table with MUI DataGrid */}
        <Card className="admin-data-card">
          <div style={{ minHeight: 600, width: "100%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 15 },
                },
                // ADDED: Default sorting by created_at in descending order
                sorting: {
                  sortModel: [{ field: "created_at", sort: "desc" }],
                },
              }}
              pageSizeOptions={[15, 25, 50, 100]}
              disableRowSelectionOnClick
              sx={{
                "& .MuiDataGrid-cell": {
                  fontSize: "11.5px",
                  fontWeight: "bold",
                },
              }}
            />
          </div>
        </Card>

        {/* REMOVED: Manual Pagination component */}
        {/* <Row className="py-4 d-flex w-100 justify-content-center">
                    <Pagination usersPerPage={usersPerPage} totalUsers={users.length} paginate={paginate} />
                </Row> */}
      </div>
    </>
  );
};

export default UsersList;
